import { Component, OnInit } from '@angular/core';
import { SessionService } from './shared/services/session/session.service';
import { SignalrService } from './shared/services/signalr/signalr.service';
import { InitialStateService } from './shared/services/initial-state/initial-state.service';
import { environment } from '../environments/environment';
import { LoginService } from './shared/services/login/login.service';
import { SettingsService } from './shared/services/settings/settings.service';
import { WinningPlanService } from './shared/services/winning-plan/winning-plan.service';
import { ActivatedRoute, Params } from '@angular/router';
import {IdleStateService} from './shared/services/idle-state.service';

@Component({
    selector: 'vit-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(public sessionService: SessionService,
                public signalrService: SignalrService,
                public initialStateService: InitialStateService,
                public loginService: LoginService,
                public settingsService: SettingsService,
                public winningPlanService: WinningPlanService,
                public idle: IdleStateService) {
      this.idle.init();
    }

    async ngOnInit() {
        this.initialStateService.fetchInitialState();
        this.winningPlanService.fetchWinningPlan();

        if (environment.production) {
            this.signalrService.init();
        }

        this.loginService.validateUserAccount();
        this.settingsService.fetchSettings();
    }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/app.component.ts